import Button from 'components/forms/Button'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import { FAQPageJsonLd } from 'next-seo'
import { convert } from 'html-to-text'
import { useRouter } from 'next/router'
import useShoppingBag from 'common/useShoppingBag'
import { ButtonType } from '../../../types/global'

const questionAndAnswer = [
  {
    answer: `For the mail forwarding add-on, all of your costs are included in the add-on of ${planPrice.monthlyOnYearlyPlan(
      `${PlanSlug.SCAN_PRO}-addon`,
    )} per extra per month. <br/> <br/>For the pay as you go option, we apply a process charge per mail item sent of 50p, as well as the cost of First Class postage. <br/> <br/>For our collection service, you can collect your important mail anytime within 30 days of us receiving the mail.`,
    question: 'How much does mail forwarding cost?',
  },
  {
    answer: `Mail forwarding is an essential service for the most important pieces of business mail. Some businesses require physical copies of their mail, some just need the occasional piece of important business mail forwarding to them, others just want to come and collect their mail once every 30-days. <br/> <br/>Whatever you need physical copies of your business mail for, our mail forwarding service gives you the option to get it. However you want.`,
    question: 'Why do I need mail forwarding?',
  },
  {
    answer: `You can add and remove the mail forwarding option on your account anytime you choose: either sign up and add it at check-out and you are set to go. You can also add it at a later date. <br/> <br/>You can also cancel the mail forwarding service at any point with our monthly subscription charging. We will forward mail until you don’t need it anymore. <br/> <br/><strong class='color-black1'>No set-up or handling fees.</strong>`,
    question: 'Do I need to buy the Mail Forwarding add-on when I sign up?',
  },
  {
    answer: `Your mail will be forwarded to whichever address you decide to use. Usually this is the address that you have assigned in your account profile. Essentially, your business mail can get sent to you anywhere in the UK.`,
    question: 'Where will my important business mail get sent?',
  },
  {
    answer: `No. Our mail forwarding service only covers UK addresses. <br/> <br/>Your scanned copy of your business mail will get sent to you digitally - you can access that anywhere you have an internet connection.`,
    question: 'Can you forward my business mail abroad?',
  },
]

const MailForwardingDetails = ({ planSummary }) => {
  const router = useRouter()
  const { addPlan } = useShoppingBag()

  const onBuyClick = () => {
    addPlan(
      planSummary.slug,
      'year',
      planSummary,
      ButtonType.MAIL_FORWARDING_DETAILS_CARD,
    )
    router.push('/checkout')
  }
  const faqJSONLd = questionAndAnswer?.map((v) => ({
    acceptedAnswerText: convert(v.answer),
    questionName: v.question,
  }))
  return (
    <div>
      <FAQPageJsonLd mainEntity={faqJSONLd} />

      <h2 className='fw-semibold text-center mb-lg-18 mb-12 px-14 fs-fluid-36-80 lh-105'>
        Mail forwarding: <span className='color-pink2'>the details</span>.
      </h2>
      <div className='d-flex flex-column gap-5'>
        {questionAndAnswer.map((item) => (
          <div key={item.question}>
            <h3 className='fw-semibold fs-fluid-24-32'>{item.question}</h3>
            <div
              className='fw-semibold color-grey5 fs-fluid-18-24'
              dangerouslySetInnerHTML={{ __html: item.answer }}
            />
          </div>
        ))}
      </div>
      <h2 className='fw-semibold mt-12 mt-lg-15 mb-6 text-center text-lg-start fs-fluid-24-40'>
        Get started today with our virtual office plan.
      </h2>
      <Button onClick={onBuyClick} className='w-100 w-lg-auto align-self-start'>
        Buy Now
      </Button>
    </div>
  )
}

export default MailForwardingDetails
